import type { FC, SyntheticEvent } from "react";
import { memo } from "react";

import { ReactComponent as EditIcon } from "@src/core/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "@src/core/icons/delete.svg";
import { MenuItem, MenuText, MenuWrapper } from "./workspace-menu.styles";
import type { WorkspaceMenuProps } from "./workspace-menu.types";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "@src/core/constants";

export const WorkspaceMenu: FC<WorkspaceMenuProps> = memo(
  ({
    open,
    spaceId,
    spaceIndex,
    setSpaceIndex,
    deleteWorkspace,
    setSpaceIdByClick,
  }) => {
    const navigate = useNavigate();

    const workspaceUpdate = (e: SyntheticEvent) => {
      e.preventDefault();
      navigate(`${APP_ROUTES.WORKSPACE}/update/${spaceId}`);
      setSpaceIndex(spaceIndex);
      e.stopPropagation();
    };

    return (
      <>
        {open && (
          <MenuWrapper>
            <MenuItem onClick={workspaceUpdate}>
              <EditIcon />
              <MenuText>Редактировать</MenuText>
            </MenuItem>
            <MenuItem onClick={deleteWorkspace}>
              <DeleteIcon />
              <MenuText>Удалить</MenuText>
            </MenuItem>
          </MenuWrapper>
        )}
      </>
    );
  },
);
